import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = {
  key: 0,
  class: "avatar-container"
}
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "text__main type-subtitle-04" }
const _hoisted_5 = {
  key: 0,
  class: "text__subtitle"
}
const _hoisted_6 = {
  key: 1,
  class: "icon-right"
}
const _hoisted_7 = {
  key: 1,
  class: "chevron"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "add-action" }
const _hoisted_10 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Tick = _resolveComponent("Tick")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_VueDraggableNext = _resolveComponent("VueDraggableNext")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createVNode(_component_VueDraggableNext, {
        disabled: !(_ctx.actionNav && _ctx.editMode),
        class: _normalizeClass(["list-group w-full", _ctx.editMode ? 'dragArea' : '']),
        list: _ctx.items,
        onStart: _ctx.startDragging,
        onEnd: _ctx.endDragging
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _renderSlot(_ctx.$slots, "default", { item: item }, () => [
                _createVNode(_component_router_link, {
                  class: _normalizeClass({
                active: (item.url && item.url === _ctx.activeItem) || item?.active,
                'draggable-item': _ctx.actionNav && _ctx.editMode && !_ctx.dragging,
                'dragged-item': _ctx.actionNav && _ctx.editMode && _ctx.dragging,
              }),
                  to: item.url,
                  onClick: ($event: any) => (_ctx.handleClick($event, item))
                }, {
                  default: _withCtx(() => [
                    (_ctx.showAvatar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_Avatar, {
                            size: "sm",
                            image: item.imgUrl,
                            alt: item.title,
                            text: item?.text ?? ''
                          }, null, 8, ["image", "alt", "text"])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "drag-icon",
                          icon: "up-down"
                        }),
                        _createElementVNode("span", {
                          onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                        }, [
                          _createVNode(_component_TranslatedText, {
                            path: item.title
                          }, null, 8, ["path"])
                        ], 32)
                      ]),
                      (_ctx.showSubtitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.getSubtitle(item.subtitle ?? "")), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.showIconRight)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (item.type === 'link')
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: "link"
                              }))
                            : _createCommentVNode("", true),
                          (!item.completed && item.type !== 'link')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " > "))
                            : _createCommentVNode("", true),
                          (item.completed)
                            ? (_openBlock(), _createBlock(_component_Tick, {
                                key: 2,
                                active: "",
                                round: "",
                                class: "ml-1"
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["class", "to", "onClick"])
              ], true)
            ]))
          }), 128))
        ]),
        _: 3
      }, 8, ["disabled", "class", "list", "onStart", "onEnd"]),
      (_ctx.actionNav && _ctx.editMode)
        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: "/",
                custom: ""
              }, {
                default: _withCtx(({ href, navigate }) => [
                  (_ctx.editMode)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleCreateAction()))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "plus-circle" }),
                        _cache[2] || (_cache[2] = _createTextVNode("  ADD NEW ACTION", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: href,
                        onClick: navigate
                      }, " Go to route in \"to\" ", 8, _hoisted_10))
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}